export default "__VITE_ASSET__OGzbWH0a__"